import { render, staticRenderFns } from "./UiCenterEllipsis.vue?vue&type=template&id=0d451b8c"
import script from "./UiCenterEllipsis.vue?vue&type=script&lang=js"
export * from "./UiCenterEllipsis.vue?vue&type=script&lang=js"
import style0 from "./UiCenterEllipsis.vue?vue&type=style&index=0&id=0d451b8c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports